module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [(_vm.title.length) ? _c('Title', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.links.length) ? _c('ol', {
    staticClass: "links__list"
  }, _vm._l((_vm.linkAndDescription), function(ref, index) {
    var link = ref.link;
    var description = ref.description;

    return _c('li', {
      key: index,
      staticClass: "links__item"
    }, [(link.length) ? [(link.length) ? _c('a', {
      staticClass: "links__link",
      attrs: {
        "href": link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link))]) : _vm._e()] : _vm._e(), (link.length && description.length) ? [_vm._v(" — ")] : _vm._e(), (description.length) ? [_vm._v(_vm._s(description))] : _vm._e()], 2)
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58023cbe","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/compopnents/block/components/itemsblock/components/links/Links.vue
// module id = 6c136f6de273f9d7ddf7
// module chunks = 89